import type {ReactElement} from 'react';
import React from 'react';
import {BaseStylingOptions} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-styling-options';
import {TOOLTIP_POSITION} from '@Components/tooltip';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTextStylesActiveItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesActiveItem';

interface ItemStylingOptionsProps {
  tooltipClassName?: string;
  tooltipPosition?: TOOLTIP_POSITION;
}

export function ItemStylingOptions({tooltipClassName = '', tooltipPosition = TOOLTIP_POSITION.BOTTOM_MIDDLE}: ItemStylingOptionsProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const isBold = useGetKeyFromTextStylesActiveItem('isBold');
  const stroke = useGetKeyFromTextStylesActiveItem('stroke');
  const isItalic = useGetKeyFromTextStylesActiveItem('isItalic');
  const lineThrough = useGetKeyFromTextStylesActiveItem('lineThrough');
  const underLine = useGetKeyFromTextStylesActiveItem('underLine');

  if (!activeItem || (activeItem && !('textStyles' in activeItem)) || isBold === undefined || isItalic === undefined || lineThrough === undefined || underLine === undefined) {
    throw new Error(`Item doesn't have textStyles property`);
  }

  const onClickBold = (): void => {
    void activeItem.updateFromObject({
      textStyles: {
        isBold: !isBold,
      },
    });
  };

  const onClickItalic = (): void => {
    void activeItem.updateFromObject({
      textStyles: {
        isItalic: !isItalic,
      },
    });
  };
  const onClickStrikeThrough = (): void => {
    void activeItem.updateFromObject({
      textStyles: {
        lineThrough: !lineThrough,
      },
    });
  };
  const onClickUnderline = (): void => {
    void activeItem.updateFromObject({
      textStyles: {
        underLine: !underLine,
      },
    });
  };

  return (
    <BaseStylingOptions
      isBold={isBold}
      isBoldDisabled={stroke}
      isItalic={isItalic}
      lineThrough={lineThrough}
      underLine={underLine}
      onClickBold={onClickBold}
      onClickItalic={onClickItalic}
      onClickLineThrough={onClickStrikeThrough}
      onClickUnderline={onClickUnderline}
      tooltipClassName={tooltipClassName}
      tooltipPosition={tooltipPosition}
    />
  );
}
